import { nowISO } from "@/shared/lib/date-time";
import type { ContractFormValues } from "./ContractForm";

type ContractFormSample = Omit<Partial<ContractFormValues>, "startDate" | "endDate"> & {
  startDate?: string;
  endDate?: string;
};

export const contractFormSamples: ContractFormSample[] = [
  {
    title: "ສັນຍາຈ້າງພະນັກງານ",
    contractNumber: "EMP-2024-001",
    typeId: "",
    status: "active",
    counterparty: "ບໍລິສັດ ABC ຈຳກັດ",
    counterpartyContact: "020-12345678, info@abc.com",
    departmentId: null,
    employeeId: null,
    responsiblePersonId: null,
    startDate: nowISO(),
    endDate: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString(),
    autoRenewal: true,
    renewalNoticeDays: 30,
    notes: "ສັນຍາຈ້າງພະນັກງານປະຈຳປີ ມີການຕໍ່ອາຍຸອັດຕະໂນມັດ",
    warnings: "ກະລຸນາກວດສອບວັນທີຫມົດອາຍຸກ່ອນ 30 ວັນ",
    specialConditions: "ພະນັກງານຕ້ອງຜ່ານການປະເມີນປະຈຳປີ",
  },
  {
    title: "ສັນຍາບໍລິການຄອມພິວເຕີ",
    contractNumber: "IT-2024-002",
    typeId: "",
    status: "active",
    counterparty: "ບໍລິສັດ XYZ Technology",
    counterpartyContact: "021-87654321, support@xyztech.com",
    departmentId: null,
    employeeId: null,
    responsiblePersonId: null,
    startDate: nowISO(),
    endDate: new Date(Date.now() + 180 * 24 * 60 * 60 * 1000).toISOString(),
    autoRenewal: false,
    renewalNoticeDays: 60,
    notes: "ສັນຍາບໍລິການຮັກສາແລະສະໜອງອຸປະກອນ IT",
    warnings: "ກວດສອບການບໍລິການປະຈຳເດືອນ",
    specialConditions: "ຕ້ອງມີການສະໜອງບໍລິການ 24/7",
  },
  {
    title: "ສັນຍາເຊື່ອສິນຄ້າ",
    contractNumber: "SUP-2024-003",
    typeId: "",
    status: "draft",
    counterparty: "ບໍລິສັດ Supplier Co., Ltd.",
    counterpartyContact: "030-11223344, sales@supplier.com",
    departmentId: null,
    employeeId: null,
    responsiblePersonId: null,
    startDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
    endDate: new Date(Date.now() + 730 * 24 * 60 * 60 * 1000).toISOString(),
    autoRenewal: true,
    renewalNoticeDays: 90,
    notes: "ສັນຍາເຊື່ອສິນຄ້າສຳລັບການຜະລິດ",
    warnings: "ກວດສອບຄຸນນະພາບສິນຄ້າກ່ອນຮັບມື",
    specialConditions: "ຕ້ອງມີການຮັບປະກັນຄຸນນະພາບ",
  },
  {
    title: "ສັນຍາບໍລິການທຳຄວາມສະອາດ",
    contractNumber: "CLN-2024-004",
    typeId: "",
    status: "active",
    counterparty: "ບໍລິສັດ Clean Service",
    counterpartyContact: "020-55667788, contact@cleanservice.com",
    departmentId: null,
    employeeId: null,
    responsiblePersonId: null,
    startDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
    endDate: new Date(Date.now() + 335 * 24 * 60 * 60 * 1000).toISOString(),
    autoRenewal: true,
    renewalNoticeDays: 30,
    notes: "ສັນຍາບໍລິການທຳຄວາມສະອາດປະຈຳເດືອນ",
    warnings: "",
    specialConditions: "ຕ້ອງມີການກວດສອບຄຸນນະພາບການບໍລິການປະຈຳອາທິດ",
  },
  {
    title: "ສັນຍາເຊື່ອອຸປະກອນ",
    contractNumber: "EQP-2024-005",
    typeId: "",
    status: "active",
    counterparty: "ບໍລິສັດ Equipment Rental",
    counterpartyContact: "021-99887766, rental@equipment.com",
    departmentId: null,
    employeeId: null,
    responsiblePersonId: null,
    startDate: nowISO(),
    endDate: new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toISOString(),
    autoRenewal: false,
    renewalNoticeDays: 15,
    notes: "ສັນຍາເຊື່ອອຸປະກອນສຳລັບໂຄງການຊົ່ວຄາວ",
    warnings: "ກວດສອບສະພາບອຸປະກອນກ່ອນຄືນ",
    specialConditions: "ຕ້ອງມີການຮັບປະກັນຄວາມປອດໄພ",
  },
  {
    title: "ສັນຍາບໍລິການການເງິນ",
    contractNumber: "FIN-2024-006",
    typeId: "",
    status: "active",
    counterparty: "ທະນາຄານ ABC",
    counterpartyContact: "020-22334455, banking@abc.com",
    departmentId: null,
    employeeId: null,
    responsiblePersonId: null,
    startDate: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString(),
    endDate: new Date(Date.now() + 305 * 24 * 60 * 60 * 1000).toISOString(),
    autoRenewal: true,
    renewalNoticeDays: 60,
    notes: "ສັນຍາບໍລິການທະນາຄານແລະການເງິນ",
    warnings: "ກວດສອບອັດຕາດອກເບ້ຍປະຈຳເດືອນ",
    specialConditions: "ຕ້ອງມີການລາຍງານການເງິນປະຈຳເດືອນ",
  },
  {
    title: "ສັນຍາບໍລິການປະກັນໄພ",
    contractNumber: "INS-2024-007",
    typeId: "",
    status: "active",
    counterparty: "ບໍລິສັດປະກັນໄພ XYZ",
    counterpartyContact: "021-33445566, insurance@xyz.com",
    departmentId: null,
    employeeId: null,
    responsiblePersonId: null,
    startDate: nowISO(),
    endDate: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString(),
    autoRenewal: true,
    renewalNoticeDays: 45,
    notes: "ສັນຍາປະກັນໄພສິນຄ້າແລະອຸປະກອນ",
    warnings: "ກວດສອບຄວາມຄົບຖ້ວນຂອງການປະກັນໄພ",
    specialConditions: "ຕ້ອງມີການອັບເດດລາຍການສິນຄ້າທີ່ປະກັນໄພປະຈຳເດືອນ",
  },
];
